import { mimshakDataService } from "../services/mimshakDataService";
import { queryKeys } from "../queries/queryKeys";
import { createMimshakHooks } from "./createMimshakHooks";

// ✅ יצירת כל ה-hooks עבור Mimshak רגיל
const hooks = createMimshakHooks({
  service: mimshakDataService,
  queryKeys: {
    byPeriod: (userId: number, period: string) => queryKeys.mimshakDataByPeriod(userId, period),
    latestRecords: (userId: number) => queryKeys.mimshakDatalatestRecords(userId),
    latestRecordsBatch: (userIds: string) => ["mimshakData", "latestRecordsBatch", userIds],
    byPeriodBatch: (userIds: string, period: string) => ["mimshakData", "byPeriodBatch", userIds, period],
  },
});

// ✅ ייצוא כל ה-hooks עם שמות חדשים
export const useMimshaksByContactAndPeriod = hooks.useMimshaksByContactAndPeriod;
export const useMimshaksByContactsAndPeriod = hooks.useMimshaksByContactsAndPeriod;
export const useLatestMimshakByContact = hooks.useLatestMimshakByContact;
export const useLatestMimshaksByContacts = hooks.useLatestMimshaksByContacts;
//export const useUpsertMimshakData = hooks.useUpsertMimshakData;
